import DashboardModule from "./DashboardModule";

export default DashboardModule;
